import { render, staticRenderFns } from "./KlarnaReturn.vue?vue&type=template&id=26206019&scoped=true"
import script from "./KlarnaReturn.vue?vue&type=script&lang=js"
export * from "./KlarnaReturn.vue?vue&type=script&lang=js"
import style0 from "./KlarnaReturn.vue?vue&type=style&index=0&id=26206019&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_css-loader@6.11.0_webpack@5.94.0__lodash@4.17.21__ar4y5aobbfwjol7cdxadoh6aqe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26206019",
  null
  
)

export default component.exports